import createHttpClient from './HttpClient'

const httpClient = createHttpClient()

export async function fetchCharacterTechniques(slug) {
  const response = await httpClient.get(`/api/v1/characters/${slug}/techniques`)
  return response.data
}

export async function learnCharacterTechnique(slug, techniqueId) {
  const response = await httpClient.post(`/api/v1/characters/${slug}/techniques/learn`, {
    techniqueId,
  })
  return response.data
}
